import type { Persister } from '@tanstack/react-query-persist-client';
import { get, set, del } from 'idb-keyval';

const CACHE_KEY = 'REACT_QUERY_OFFLINE_CACHE';

/**
 * 创建基于 IndexedDB 的持久化器
 * 使用 idb-keyval 作为 IndexedDB 的轻量级封装
 */
export function createIDBPersister(): Persister {
  return {
    persistClient: async (client: any) => {
      try {
        await set(CACHE_KEY, client);
      } catch (error) {
        console.error('[PWA] Failed to persist to IndexedDB:', error);
        throw error;
      }
    },
    restoreClient: async () => {
      try {
        const client = await get(CACHE_KEY);
        return client || undefined;
      } catch (error) {
        console.error('[PWA] Failed to restore from IndexedDB:', error);
        return undefined;
      }
    },
    removeClient: async () => {
      try {
        await del(CACHE_KEY);
      } catch (error) {
        console.error('[PWA] Failed to remove from IndexedDB:', error);
        throw error;
      }
    },
  };
}

/**
 * 清理查询缓存（用于登出时）
 */
export async function clearQueryCache() {
  try {
    await del(CACHE_KEY);
    console.log('[PWA] Query cache cleared from IndexedDB');
  } catch (error) {
    console.error('[PWA] Failed to clear query cache:', error);
  }
}
